const passwordMinimumCharacters = 6
const mandatoryFieldMinimumCharacters = 4
const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
const urlRegex =
  /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/
const errorMinimumCharacters = (fieldLength) =>
  `Minima logitud de al menos ${fieldLength} caracteres`
const errorPasswordsDoesntMatch = 'Los passwords introducidos no coinciden'
const errorEmptyField = 'Este campo no puede estar vacío'
const errorEmail = 'El email no es válido'
const errorUrl = 'La url no es válida'
const errorDate = 'La fecha no es válida'

export const validateFieldLength = (field) =>
  field.length < mandatoryFieldMinimumCharacters
    ? errorMinimumCharacters(mandatoryFieldMinimumCharacters)
    : null

export const validateEmptyField = (field) => (!field || field.length === 0 ? errorEmptyField : null)

export const validateEmail = (email) =>
  !emailRegex.test(String(email).toLowerCase()) ? errorEmail : null

export const validatePasswordMatch = (newPassword, repeatPassword) =>
  newPassword !== repeatPassword ? errorPasswordsDoesntMatch : null

export const validatePasswordLength = (password) =>
  password.length < passwordMinimumCharacters
    ? errorMinimumCharacters(passwordMinimumCharacters)
    : null

export const validateUrl = (url) => (!urlRegex.test(String(url).toLowerCase()) ? errorUrl : null)

export const validateDateGraterThan = (date, comparedDate) =>
  date < comparedDate ? errorDate : null

export const validateDateLessThan = (date, comparedDate) => (date > comparedDate ? errorDate : null)
